import ServerConfigFilesViewer from "@/components/server-config-files-viewer"
import type { MonitConfig, Server } from "@/types"

interface MonitConfigsPageProps {
  server: Pick<Server, "id" | "name" | "hostname">
  configs: MonitConfig[]
}

export default function MonitConfigsPage({
  server,
  configs,
}: MonitConfigsPageProps) {
  return (
    <ServerConfigFilesViewer
      server={server}
      configs={configs}
      pageTitle="Monit Configs"
      headingTitle="Monit Configuration Files"
      directoryPath="/etc/monit/conf-available/"
      breadcrumbTitle="Monit Configs"
    />
  )
}
